import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

// Backend [Authorize(Policy = ...)] denials return a raw 403 BEFORE any
// handler-level try/catch runs, so the ResponseWrapper envelope is NOT
// returned -- just a status code. Without this interceptor, the SPA
// silently swallows the 403 and the user gets no UX feedback (e.g.
// clicking Delete on a user as a non-Administrator -- Portal-UI #59).
@Injectable()
export class ErrorToastInterceptor implements HttpInterceptor {
  constructor(private snackBar: MatSnackBar) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Only surface 403s for Medmio API requests. Other 403s (S3 asset
    // permissions, third-party SDK probes, etc.) shouldn't trip the toast.
    if (!request.url.startsWith(environment.apiUrlBase())) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse && err.status === 403) {
          this.snackBar.open(
            "You don't have permission for that action.",
            'Ok',
          );
        }
        return throwError(() => err);
      }),
    );
  }
}
